




















































import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component({
  components: {},
  directives: {}
})
export default class ContactExistsDialog extends BaseComponent {
  @Prop()
  contact: any;

  @Prop()
  fieldLabel: string;

  dialogFlag = false;

  public form: any = {
    valid: false,
    rules: {}
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  mounted() {
    setTimeout(() => {
      this.dialogFlag = true;
    }, 100);
  }

  closeForm() {
    this.$emit('close');
  }

  loadContact() {
    this.$emit('loadContact', this.contact);
  }
}
